export enum OpacityLocation {
  BACKGROUND_ASSET = 'BACKGROUND_ASSET',
  ENTIRE_MENU = 'ENTIRE_MENU',
  SECTION_CONTAINER = 'SECTION_CONTAINER'
}
